import { createAppI18n } from './setup-i18n'

export default createAppI18n('shared')
